import { useStaffSecurity } from '../../lib/workspace-api';
import { useReauth } from './reauth';

/** The password re-ask for the staff app: the window is the workspace's policy (10 minutes until it has loaded). */
export function useStaffReauth() {
  const { data: security } = useStaffSecurity();
  return useReauth({ minutes: security?.reauthMinutes ?? 10, forgotPasswordTo: '/subdomain/admin/forgot-password' });
}
